import { supabase } from "@/services/supabase/createClient";

export const saveSemanticModel = async (connectorId: string, semanticModel: object) => {
  const { data } = await supabase
    .from("connectors")
    .select("semantic_model_id")
    .eq("resource_id", connectorId)
    .single();

  const semanticModelId = data?.semantic_model_id;

  if (!semanticModelId) {
    throw new Error("Semantic model ID not found");
  }

  const { error } = await supabase
    .from("semantic_models")
    .update({
      model: semanticModel as any,
    })
    .eq("resource_id", semanticModelId);

  if (error) {
    throw new Error(`Error saving semantic model: ${error.message}`);
  }
};
